/* eslint-disable no-undef */
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { connect, useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import * as mentorsAction from "../../actions/mentorsAction";
import * as settingActions from "../../actions/settingActions";
import { imgPath } from "../../utils/imagePath";
import { Container, Row, Col } from "react-bootstrap";
import Filter from "./filter";
import Search from "./search";
import Details from "./details";
import ReactPaginate from "react-paginate";
import PopupModalWithOk from "../../utils/helpers/popupModalOk";
import {
  selectMentor,
  waitlistMentor,
  loadFormPop,
  loadMentorDetail,
  loadRegMentors,
} from "./Slice/mentorsSlice";
import PropTypes from "prop-types";

const Index = (props) => {

  const { actions, isAuth, userInfo, programmes, setting } = props;
  const savedRole = localStorage.getItem("userRole");

  // Resolve role from Redux first, fallback to localStorage
  const resolvedRole = userInfo?.role_id || savedRole || null;

  // Normalize role (optional but recommended)
  const effectiveRole = resolvedRole === "Mentees" ? "Mentee" : resolvedRole;

  const dispatch = useDispatch();
  const { mentorsData, pagination, isProcessing } = useSelector((state) => state?.mentors);
  console.log("mentorsData Role:", mentorsData);
  const [showPopup, setShowPopup] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [userData, setUserData] = useState({});
  const [keyword, setKeyword] = useState("");
  const [searchDomain, setSearchDomain] = useState("");
  const [mentalHealth, setMentalHealth] = useState("");
  const [certifiedCoach, setCertifiedCoach] = useState("");
  const [lgbtqDiscussion, setLgbtqDiscussion] = useState("");
  const [selectedDomain, setSelectedDomain] = useState([]);
  const [allManters, setAllManters] = useState("");
  const [manters, setManters] = useState("");
  const location = useLocation();
  const [popupMessage, setPopupMessage] = useState("");


  const getMentor = async (e, mentorId) => {
    e.preventDefault();

    if (!isAuth) {
      const message = "Thank you for browsing! Help us create a meaningful mentoring engagement for you by registering in one simple step, or login if you already have an account.";

      setPopupMessage(message);
      setShowPopup(true);

      // Redirect after popup shows briefly (e.g. 2 seconds)
      setTimeout(() => {
        history("/login");
      }, 2000);
      return;
    }

    try {
      const res = await dispatch(selectMentor({ userId: userInfo.id, mentorId })).unwrap();
      const message = res?.message || "Record has been updated successfully.";
      setPopupMessage(message);
      setShowPopup(true);
    } catch (err) {
      console.error("Error selecting mentor:", err);
      setPopupMessage(err.message || "Something went wrong. Please try again.");
      setShowPopup(true);
    }
  };

  const getUserDetails = async (e, item) => {
    e.preventDefault();
    try {
      const detail = await dispatch(
        loadMentorDetail({ mentorId: item.id })
      ).unwrap();
      // Merge reg_fields (new flat object) and reg_feilds (legacy nested array) from detail
      setUserData({
        ...item,
        ...detail,
        reg_fields: detail?.reg_fields || item?.reg_fields,
        reg_feilds: detail?.reg_feilds || item?.reg_feilds,
      });
    } catch {
      // Fallback: use the list item as-is
      setUserData(item);
    }
    setModalShow(true);
  };

  const setMentorWaitlistAvailability = async (e, mentorId) => {
    e.preventDefault();
    const userId = userInfo.id;
    const request = {};
    request.userId = userId;
    request.mentorId = mentorId;
    try {
      const res = await dispatch(waitlistMentor({ userId: userInfo.id, mentorId })).unwrap();
      setPopupMessage(res?.message || "Updated successfully");
      setShowPopup(true);
    } catch (err) {
      console.error("Error adding mentor to waitlist:", err);
      setPopupMessage(err.message || "Something went wrong");
      setShowPopup(true);
    }
  };

  const siteName = setting?.name?.trim() || "Creating impactful connections for women mentees";

  useEffect(() => {
    const title = `${siteName} - Creating impactful connections for women mentees`;

    document.title = title;

    const params = new URLSearchParams(location.search);
    const request = {};

    if (params.get("sort")) {
      request.sort = params.get("sort");
      request.direction = params.get("direction");
    }
    if (params.get("page")) {
      request.page = params.get("page");
    }
    if (params.get("keyword")) {
      request.keyword = params.get("keyword");
    }
    if (params.get("domains")) {
      request.domains = params.get("domains");
    }
    if (params.get("is_available")) {
      request.is_available = params.get("is_available");
    }
    if (params.get("years_of_board_experience")) {
      request.years_of_board_experience = params.get("years_of_board_experience");
    }
    if (params.get("years_of_experience")) {
      request.years_of_experience = params.get("years_of_experience");
    }
    if (params.get("board_entity_type")) {
      request.board_entity_type = params.get("board_entity_type");
    }
    if (params.get("programmes")) {
      request.programmes = params.get("programmes");
    }
    if (params.get("mf_mental_health")) {
      request.mf_mental_health = params.get("mf_mental_health");
    }
    if (params.get("mf_certified_coach")) {
      request.mf_certified_coach = params.get("mf_certified_coach");
    }
    if (params.get("lgbtq_discussion")) {
      request.lgbtq_discussion = params.get("lgbtq_discussion");
    }
    // dispatch(loadMentors({ request, userId: isAuth ? userInfo?.id : 0 })
    dispatch(loadRegMentors({ request, userId: isAuth ? userInfo?.id : 0 })
    );

    setViewPage(request.page ? Number(request.page) - 1 : 0);
    document
      .querySelector('meta[name="description"]')
      ?.setAttribute(
        "content",
        "vLookUp mentors are inspiring and empowering role models, have deep passion for growing talent and believe in fostering diversity."
      );
  }, [siteName, location.search, userInfo, isAuth,]);

  const handleFilterChange = (updatedFilters) => {
    const params = new URLSearchParams(location.search);

    for (const key of Object.keys(updatedFilters)) {
      const value = updatedFilters[key];
      if (Array.isArray(value)) {
        if (value.length > 0) params.set(key, value.join(","));
        else params.delete(key);
      } else if (value) {
        params.set(key, value);
      }
      else params.delete(key);
    };
    params.set("page", 1); // reset page on filter change
    history(`/mentors?${params.toString()}`);
  };

  const history = useNavigate();
  const resetPage = (e) => {
    e.preventDefault();
    // Reset local states
    setSelectedDomain([]);
    setCertifiedCoach("");
    setLgbtqDiscussion("");
    setMentalHealth("");
    setSearchDomain("");
    setKeyword("");
    setManters("");
    setAllManters("");
    // Clear URL params completely
    history("/mentors");
    // clear any stored filters in Filter component
    if (typeof globalThis !== "undefined") {
      globalThis.history.replaceState({}, document.title, "/mentors");
    }
  };

  const searchData = (data) => {
    const params = new URLSearchParams(location.search);
    if (data.keyword) {
      params.set("keyword", data.keyword);
    }
    history(`/mentors?${params.toString()}`);
  };

  const handleFormClick = (item, action) => {
    dispatch(loadFormPop(action));
  };

  useEffect(() => {
    actions.getAllProgrammes();
    actions.getSettingData();
  }, []);

  const [viewPage, setViewPage] = useState(0);
  const handlePageClick = (data) => {
    setViewPage(data.selected);
    let page = data.selected + 1;
    const params = new URLSearchParams(location.search);
    params.set("page", page);
    history(`/mentors?${params.toString()}`, { replace: true });
    window.scrollTo(0, 0);
  };

  const getFieldValueAndStatus = (item, field) => {
    if (!item) return false;

    if (field === "name") {
      const firstName = item?.reg_fields?.first_name || item?.first_name;
      const lastName = item?.reg_fields?.last_name || item?.last_name;
      const fullName =
        item?.full_name ||
        [firstName, lastName].filter(Boolean).join(" ");

      return (
        fullName !== null &&
        fullName !== undefined &&
        fullName !== "" &&
        fullName !== "null" &&
        fullName !== "undefined"
      );
    }

    let value = item?.reg_fields?.[field] ?? item?.[field];

    if (value === undefined && field === "objective") {
      value = item?.all_objective;
    }

    return (
      value !== null &&
      value !== undefined &&
      value !== "" &&
      value !== "null" &&
      value !== "undefined"
    );
  };

  const renderAvailability = (item) => {
    if (!item?.user_availability_check) return null;

    if (
      item?.is_reached_limit === 0 &&
      item?.user_availability_check?.availability === 1
    ) {
      return (
        <span className="AvailabilityStatus m-3">
          Available
        </span>
      );
    }

    return (
      <span className="UnavailabilityStatus m-3">
        Unavailable
      </span>
    );
  };

  const getAvailabilityBadge = (item) => {
    if (!item?.user_availability_check) return null;

    const isAvailable =
      item?.is_reached_limit === 0 &&
      item?.user_availability_check?.availability === 1;

    return (
      <span
        className={
          isAvailable
            ? "AvailabilityStatus m-3"
            : "UnavailabilityStatus m-3"
        }
      >
        {isAvailable ? "Available" : "Unavailable"}
      </span>
    );
  };

  /**
   * Render the dynamic reg_fields section on a mentor card.
   * Keys arrive in admin-defined order (drag-and-drop) and only enabled
   * fields are present in the object, so we just iterate and render.
   *
   * We skip fields that are already rendered via dedicated card UI:
   *  - "image"      → rendered as <img> above
   *  - "is_privacy" → internal flag, never displayed
   *  - "first_name" / "last_name" → composed into full_name, rendered via getFieldValueAndStatus("name")
   *
   * These are derived from what the card explicitly handles, not a static list.
   * Any field the admin adds that isn't in this set will render automatically.
   */
  const renderCardRegFields = (item) => {
    const regFields = item?.reg_fields;
    if (!regFields || typeof regFields !== "object") return null;

    // Fields already handled by dedicated card UI — derived from card structure, not hardcoded business logic
    const dedicatedCardFields = new Set([
      "image",       // rendered as <img>
      "is_privacy",  // internal flag
      "first_name",  // composed into full_name via getFieldValueAndStatus("name")
      "last_name",   // composed into full_name via getFieldValueAndStatus("name")
      "country",
      "country_image_path",
      "main_area",
      "full_name"
    ]);

    return Object.entries(regFields).map(([key, value]) => {
      if (dedicatedCardFields.has(key)) return null;
      if (!value || value === "null" || value === "undefined") return null;

      if (key === "domains") {
        value = value.split("||")[0];
      }

      return (
        <h5
          key={key}
          className={`reg-field reg-field--${key}`}
        >
          {value}
        </h5>
      );
    });
  };

  return (
    <div>
      <section className="outer_main">
        <Container className="page_heading text-center">
          <h1 style={{ fontSize: "24px", fontWeight: "700" }}>
            Find Your Mentor ({pagination?.total}){" "}
          </h1>
        </Container>

        <div className="page_content">
          <Container>
            <div className="page_content_inner">
              <Search
                onClick={resetPage}
                onSearch={searchData}
                handleFormClick={handleFormClick}
                programmes={programmes}
                keyword={keyword}
                setKeyword={setKeyword}
                allManters={allManters}
                setAllManters={setAllManters}
                manters={manters}
                setManters={setManters}
              />
              <Row>
                <Col id="left_sidebar" md={4} lg={3}>
                  <Filter
                    setting={setting}
                    onFilterChange={handleFilterChange}
                    resetPage={resetPage}
                    searchDomain={searchDomain}
                    setSearchDomain={setSearchDomain}
                    mentalHealth={mentalHealth}
                    setMentalHealth={setMentalHealth}
                    certifiedCoach={certifiedCoach}
                    setCertifiedCoach={setCertifiedCoach}
                    lgbtqDiscussion={lgbtqDiscussion}
                    setLgbtqDiscussion={setLgbtqDiscussion}
                    selectedDomain={selectedDomain}
                    setSelectedDomain={setSelectedDomain}
                  />
                </Col>

                {isAuth && (
                  <Col md={8} lg={9}>
                    <Row className="mentor_list">
                      {mentorsData?.length > 0 ? (
                        mentorsData?.map((item, key) => (
                          <Col xs={12} xl={4} lg={4} md={6} sm={6} key={item.id}>
                            <div className="outer position-relative">
                              <div className="mentor_img">
                                {renderAvailability(item)}
                                {/* Profile image: prefer reg_fields.image, fallback to item.image */}
                                <img
                                  src={item?.reg_fields?.image || item.image || imgPath + "mentor_women_two.png"}
                                  alt="professional consultants for women"
                                />
                              </div>
                              <div className="mentor_info">
                                {/* Country flag — structural, not in reg_fields */}
                                {item?.reg_fields?.country &&
                                  item?.country_image_path && (
                                    <span>
                                      <img
                                        src={item.country_image_path}
                                        alt={item.reg_fields.country}
                                        className="country_flag"
                                      />
                                    </span>
                                  )}
                                {/* Full name — structural */}
                                {/* {(item?.reg_fields?.first_name ||
                                  item?.reg_fields?.last_name) && (
                                    <h3>
                                      {item?.reg_fields?.first_name}{" "}
                                      {item?.reg_fields?.last_name}
                                    </h3>
                                  )} */}

                                {(
                                  item?.reg_fields?.full_name ||
                                  item?.full_name ||
                                  item?.reg_fields?.first_name ||
                                  item?.reg_fields?.last_name
                                ) && (
                                    <h3>
                                      {
                                        item?.reg_fields?.full_name ||
                                        item?.full_name ||
                                        `${item?.reg_fields?.first_name || ""} ${item?.reg_fields?.last_name || ""}`.trim()
                                      }
                                    </h3>
                                  )}

                                {/* Dynamic reg_fields — rendered in admin-defined order */}
                                {renderCardRegFields(item)}
                                {/* Domains — structural, sourced from main_area not reg_fields */}
                                {getFieldValueAndStatus("domains") &&
                                  item?.main_area && item?.main_area !== "undefined" && (
                                    <h5>{item.main_area}</h5>
                                  )}
                              </div>
                              <div className="mentor_btn">
                                {" "}
                                <div>
                                  {effectiveRole !== "Mentor" &&
                                    item.is_relationship === 0 &&
                                    item.is_mentor_terminate === 0 &&
                                    item.is_same_program === 1 && (
                                      <>
                                        {item.is_reached_limit === 0 &&
                                          item?.user_availability_check?.availability === 1 ? (
                                          <Link
                                            to=""
                                            onClick={(e) => {
                                              getMentor(e, item.id);
                                            }}
                                          >
                                            Indicate as Preferred Mentor
                                          </Link>
                                        ) : (
                                          <Link
                                            to=""
                                            onClick={(e) => {
                                              setMentorWaitlistAvailability(
                                                e,
                                                item.id
                                              );
                                            }}
                                          >
                                            Waitlist for availability
                                          </Link>
                                        )}
                                      </>
                                    )}
                                  <Link
                                    to=""
                                    id={key}
                                    onClick={(e) => {
                                      getUserDetails(e, item);
                                    }}
                                  >
                                    {"Read More"}
                                  </Link>
                                </div>
                              </div>
                            </div>
                          </Col>
                        ))
                      ) : (
                        <div
                          style={{ margin: "auto", height: "300px" }}
                          className="d-flex align-items-center"
                        >
                          No records found
                        </div>
                      )}
                    </Row>

                    {pagination?.total_pages &&
                      pagination?.total ? (
                      <ReactPaginate
                        breakLabel={"..."}
                        previousLabel={"<"}
                        nextLabel={">"}
                        forcePage={viewPage}
                        pageCount={pagination.total_pages}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={2}
                        onPageChange={(v) => handlePageClick(v)}
                        containerClassName={"pagination"}
                        subContainerClassName={"pages pagination"}
                        activeClassName={"active"}
                      />
                    ) : (
                      ""
                    )}
                  </Col>
                )}

                {!isAuth && (
                  <Col md={8} lg={9}>
                    <Row className="mentor_list">
                      {mentorsData?.length > 0 ? (
                        mentorsData?.map((item, key) => (
                          <Col xs={12} xl={4} lg={4} md={6} sm={6} key={item.id}>
                            <div className="outer position-relative">
                              <div className="mentor_img">
                                {getAvailabilityBadge(item)}
                                <img
                                  src={item?.reg_fields?.image || item?.image || imgPath + "mentor_women_two.png"}
                                  alt="find a career mentor online"
                                />
                              </div>
                              <div className="mentor_info">
                                {/* Country flag — structural */}
                                {getFieldValueAndStatus(item, "country") && item.country_image_path && (
                                  <span>
                                    <img
                                      src={item.country_image_path}
                                      alt="professional consultants for women"
                                      className="country_flag"
                                    />
                                  </span>
                                )}
                                {/* Full name — structural */}
                                {getFieldValueAndStatus(item, "name") && (
                                  <h3>{item?.full_name}</h3>
                                )}
                                {/* Dynamic reg_fields — rendered in admin-defined order */}
                                {renderCardRegFields(item)}
                                {/* Domains — structural */}
                                {getFieldValueAndStatus(item, "domains") &&
                                  item?.main_area && item?.main_area !== "undefined" && (
                                    <h5>{item.main_area}</h5>
                                  )}
                              </div>
                              <div className="mentor_btn">
                                {" "}
                                <div>
                                  {userInfo?.role_id !== "Mentor" && (
                                    <Link
                                      to=""
                                      onClick={(e) => {
                                        getMentor(e, item.id);
                                      }}
                                    >
                                      Indicate as Preferred Mentor
                                    </Link>
                                  )}
                                  <Link
                                    to=""
                                    id={key}
                                    onClick={(e) => {
                                      getUserDetails(e, item);
                                    }}
                                  >
                                    {"Read More"}
                                  </Link>
                                </div>
                              </div>
                            </div>
                          </Col>
                        ))
                      ) : (
                        <div
                          style={{ margin: "auto", height: "300px" }}
                          className="d-flex align-items-center"
                        >
                          No records found
                        </div>
                      )}
                    </Row>
                    {pagination?.total_pages && pagination?.total ? (
                      <ReactPaginate
                        previousLabel={"<"}
                        nextLabel={">"}
                        siblingCount={5}
                        forcePage={viewPage}
                        breakLabel={"..."}
                        breakClassName={"break-me"}
                        pageCount={pagination.total_pages}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={2}
                        onPageChange={(v) => handlePageClick(v)}
                        containerClassName={"pagination"}
                        subContainerClassName={"pages pagination"}
                        activeClassName={"active"}
                      />
                    ) : (
                      ""
                    )}
                  </Col>
                )}
              </Row>
            </div>
          </Container>
        </div>
      </section>
      {modalShow && (
        <Details
          getFieldValueAndStatus={getFieldValueAndStatus}
          show={modalShow}
          setting={setting}
          userdata={userData}
          onHide={() => setModalShow(false)}
          centered
          size="xl"
          className="mentor_modal"
        />
      )}

      {/* Success Popup */}
      <PopupModalWithOk
        show={showPopup}
        onHide={() => setShowPopup(false)}
        message={popupMessage}
        showConfirm={false}
        staticBackdrop={true}
      />

      {isProcessing && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.3)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <i
            className="fas fa-spinner fa-spin"
            style={{
              fontSize: "50px",
              color: "#007bff",
            }}
          />
        </div>
      )}
    </div>
  );
};

Index.propTypes = {
  actions: PropTypes.object.isRequired,
  isAuth: PropTypes.bool.isRequired,
  userInfo: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    role_id: PropTypes.string,
  }).isRequired,
  programmes: PropTypes.arrayOf(PropTypes.object).isRequired,
  setting: PropTypes.shape({
    name: PropTypes.string,
    mentor_fields_json: PropTypes.arrayOf(
      PropTypes.shape({
        field: PropTypes.string,
        value: PropTypes.string,
      })
    ),
  }).isRequired,
};

function mapStateToProps(state) {
  return {
    mentorsData: state.mentorsData,
    pagination: state.pagination,
    isAuth: state.isAuth,
    setting: state.setting,
    userInfo: state.userInfo,
    programmes: state.programmes,
    userExperience: state.userExperience,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      { ...mentorsAction, ...settingActions },
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Index);
